import type { ItemSlot } from "./view-model";
import { PixelIcon } from "./PixelIcon";

export interface ZonesProps {
  onSelectSlot(slot: ItemSlot): void;
  onSelectShell?(): void;
  onSelectWater?(): void;
}

export function Zones({ onSelectSlot, onSelectShell, onSelectWater }: ZonesProps) {
  return (
    <div id="zones" data-testid="zones">
      <button
        className="edit-corner-btn edit-shell-btn"
        type="button"
        data-testid="edit-shell-button"
        aria-label="Change shell"
        onClick={(e) => {
          e.stopPropagation();
          onSelectShell?.();
        }}
      >
        <PixelIcon name="shell" size={24} />
      </button>
      <button
        className="edit-corner-btn edit-water-btn"
        type="button"
        data-testid="edit-water-button"
        aria-label="Change water"
        onClick={(e) => {
          e.stopPropagation();
          onSelectWater?.();
        }}
      >
        <PixelIcon name="water" size={24} />
      </button>
      <button
        className="zone"
        type="button"
        aria-label="Change decoration"
        style={{ left: "4%", top: "35%", width: "26%", height: "60%" }}
        onClick={(e) => {
          e.stopPropagation();
          onSelectSlot("decoration");
        }}
      >
        <span>Decoration</span>
      </button>
      <button
        className="zone"
        type="button"
        aria-label="Change toy"
        style={{ left: "26%", top: "81%", width: "14%", height: "17%" }}
        onClick={(e) => {
          e.stopPropagation();
          onSelectSlot("toy");
        }}
      >
        <span>Toy</span>
      </button>
      <button
        className="zone"
        type="button"
        aria-label="Change companion"
        style={{ left: "69%", top: "36%", width: "29%", height: "61%" }}
        onClick={(e) => {
          e.stopPropagation();
          onSelectSlot("companion");
        }}
      >
        <span>Companion</span>
      </button>
    </div>
  );
}
